<template>
  <div class="profile-tab-content">
    <section class="cart-section">
      <div class="container">
        <form style="display: flex; flex-direction: column; align-items: center;" v-on:submit.prevent="onApplicationSubmit">
          <div class="flex-column justify-content-center align-items-center" style="display: flex;">
            <div class="" >
              <div class="checkout-page">
                <div class="checkout-form theme-form">
                  <div class="row center-content">
                    <div class="col-lg-12 col-sm-12 col-xs-12">
                      <div class="theme-card check-out ng-star-inserted">
                        <div class="row justify-content-center align-items-center" style="display: flex;">
                          <div class="form-group col-md-12 col-sm-12 col-xs-12" style="margin-bottom:30px">
                            <div class="field-label-modern" style="margin-bottom:20px">
                              <h4 style="font-size: 18px; font-weight: 600; color: #2c3e50; margin: 0; letter-spacing: 0.5px;">Select Your Unit</h4>
                              <p style="font-size: 13px; color: #6c757d; margin: 5px 0 0 0;">Choose the unit you wish to apply for</p>
                            </div>
                            <div class="unit-selection-grid">
                              <div
                                v-for="unit in units"
                                :key="unit"
                                class="unit-card"
                                :class="{
                                  'unit-card-selected': applicationForm.unit === unit,
                                  'unit-card-eligible': unitObj[unit],
                                  'unit-card-ineligible': !unitObj[unit]
                                }"
                                @click="selectUnit(unit)"
                              >
                                <input
                                  class="unit-radio-hidden"
                                  v-model="applicationForm.unit"
                                  type="radio"
                                  name="unit"
                                  :id="'unit'+unit"
                                  :value="unit"
                                  @change="getUnitValues"
                                >
                                <div class="unit-card-content">
                                  <div class="unit-check-indicator">
                                    <i v-if="applicationForm.unit === unit" class="fa fa-check-circle"></i>
                                    <i v-else class="fa fa-circle-o"></i>
                                  </div>
                                  <div class="unit-label">{{ unit }}</div>
                                  <div v-if="!unitObj[unit]" class="unit-status-badge">
                                    <i class="fa fa-times-circle"></i> Not Eligible
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <!-- Show you are not eligible -->
                          <div v-if="!closeCall && !unitObj[applicationForm.unit]" class="col-md-12 col-sm-12 col-xs-12" style="margin-bottom:25px">
                            <h3 class="text-danger">You are not eligible for this Unit.</h3>
                          </div>
                          <div class="middle-center col-12" v-show="onApplicationLoading">
                            <global-spinner :animation-duration="1500" :size="50" color="#2196f3" />
                          </div>
                          <div class="middle-cente<r col-12" v-show="onApplicationLoading">

                          </div>
                          <div v-if="unitObj[applicationForm.unit] && applicationForm.quotaObj!=null && unitObj[applicationForm.unit]" class="form-grou col-md-12 col-sm-12 col-xs-12" style="margin-bottom:25px">
                            <div class="field-label" style="line-height:24px;margin-bottom:10px" >Quota</div>
                            <div class="row">
                              <div class="col-md-2 col-xs-4" style="margin-bottom:10px"  v-for="(quota,key) in applicationForm.quotaObj" :key="key">
                                <div class="form-check form-check-inline" style="width:100%">
                                  <input class="form-check-input" disabled v-model="applicationForm.quotaObj[key].value" style="margin-top:.25em" type="checkbox" :name="'pQuota'+key" :id="'pQuota'+key" :value=true>
                                  <label class="form-check-label" :for="'pQuota'+key">{{key}}</label>
                                </div>
                                <div class="form-group" style="width:100%;margin-top:5px" v-if="applicationForm.quotaObj[key]['sub-quota']!=null && applicationForm.quotaObj[key].value">
                                  <select disabled :name="'pSubQuota'+key" style="padding: 0px 15px 0px 5px;height: 25px;" value="" v-model="applicationForm.quotaObj[key].subQuotaName" placeholder="Sub Quota" autocomplete="off" class="ng-untouched ng-pristine ng-invalid" required>
                                    <option value="">Sub Quota</option>
                                    <option v-for="(subQuota,value) in applicationForm.quotaObj[key]['sub-quota']" :key="value" :value="value" class="ng-star-inserted">{{value}}</option>
                                  </select>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div v-if="unitObj[applicationForm.unit] && applicationForm.quotaObj!=null" class="form-group col-md-12 col-sm-12 col-xs-12" style="margin-bottom:25px">
                            <div class="field-label" style="line-height:24px;margin-bottom:10px" >Quota</div>
                            <div class="form-check form-check-inline" v-for="quota in quotas" :key="quota">
                              <input class="form-check-input" v-if="applicationApplicable" v-model="applicationForm.quotaObj[quota].value" style="margin-top:.25em" type="checkbox" :name="'quota'+quota" :id="'quota'+quota" :value=true>
                              <input class="form-check-input" v-else disabled v-model="applicationForm.quotaObj[quota].value" style="margin-top:.25em" type="checkbox" :name="'quota'+quota" :id="'quota'+quota" :value=true>
                              <label class="form-check-label" :for="'quota'+quota">{{quota}}</label>
                            </div>
                          </div>
                          <div class="row"  v-if="unitObj[applicationForm.unit] && applicationForm.quotaObj!=null">
                            <div class="row" v-for="quota in quotas" :key="quota">
                              <div class="row" v-if="applicationForm.quotaObj[quota].value">
                                <div v-if="applicationForm.quotaObj[quota].value" class="form-grou col-md-12 col-sm-12 col-xs-12" style="">
                                  <div v-if="applicationForm.quotaObj[quota]['sub-quota']!=null" class="field-label" style="line-height:24px;margin-bottom:10px" >{{quota}} Sub-Quotas</div>

                                  <div class="form-check form-check-inline" v-for="(subQuota,value) in applicationForm.quotaObj[quota]['sub-quota']" :key="subQuota" style="margin-bottom:20px">
                                    <input class="form-check-input" v-if="applicationApplicable" v-model="applicationForm.quotaObj[quota]['sub-quota'][value]" style="margin-top:.25em" type="checkbox" :name="'u'+applicationForm.unit+'sub'+value+'Quota'+quota" :id="'u'+applicationForm.unit+'sub'+value+'Quota'+quota" value="true">
                                    <input class="form-check-input" v-else disabled v-model="applicationForm.quotaObj[quota]['sub-quota'][value]" style="margin-top:.25em" type="checkbox" :name="'u'+applicationForm.unit+'sub'+value+'Quota'+quota" :id="'u'+applicationForm.unit+'sub'+value+'Quota'+quota" value="true">
                                    <label class="form-check-label" :for="'u'+applicationForm.unit+'sub'+value+'Quota'+quota">{{value}}</label>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="flex-wrap" style="display:flex">
                            <div v-if="unitObj[applicationForm.unit] && (unitObj[applicationForm.unit] && applicationForm.unit!='' && applicationForm.bill_number != '') && (applicationForm.amount != '' && !onApplicationLoading)" class="form-group col-12 col-lg-6 col-md-12 col-sm-12 col-xs-12">
                              <div class="field-label">Bill Number</div>
                              <input type="text" id="bill_numberApp" name="bill_number" placeholder="Bill Number" class="ng-untouched ng-pristine ng-invalid" v-model="applicationForm.bill_number" disabled>
                            </div>
                            <div class="form-group col-12 col-lg-6 col-md-12 col-sm-12 col-xs-12" v-if="unitObj[applicationForm.unit] && (applicationForm.unit!='' && unitObj[applicationForm.unit]) && (applicationForm.amount!='' && !onApplicationLoading)">
                              <div class="field-label">Amount</div>
                              <div class="row">
                                <div class="col-lg- col-xs-4">
                                  <input type="text" id="fee" disabled name="amount" placeholder="Fee" class="ng-untouched ng-pristine ng-invalid" v-model="applicationForm.amount">
                                </div>
                                <div class="col-md-3 col-sm-3 col-xs-3">
                                  <div class="mb-2" style="font-weight: 600;margin-top:3px;font-size:22px;" v-if="applicationForm.status!='' && applicationForm.status!=null">
                                    <b-badge v-if="applicationForm.bill_status=='confirmed'" style="text-transform: uppercase;" variant="success">
                                      PAID
                                    </b-badge>
                                    <b-badge v-else-if="applicationForm.status!='applied'" style="text-transform: uppercase;" variant="success">
                                      {{applicationForm.bill_status}}
                                    </b-badge>
                                    <b-badge v-else variant="danger">
                                      DUE
                                    </b-badge>
                                  </div>
                                </div>

                                
                              </div>
                              <!-- <div class="col-md-5">
                                  <button v-if="!closePaymentSlip && (applicationForm.bill_status=='confirmed' || applicationForm.bill_status=='paid')" class="btn info-btn btn-info radius-1" type="button" @click="onApplicationPaySlip" block>
                                    Payment Slip
                                  </button>
                                </div> -->
                            </div> 
                             <div v-else class="form-group col-12 col-lg-6 col-md-12 col-sm-12 col-xs-12">

                             </div>
                          </div>
                          
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div style="padding-bottom:25px; display: flex;" v-if="(applicationForm.unit!='' && !onApplicationLoading) && unitObj[applicationForm.unit]" class="form-group row col-12 flex-column justify-content-center align-items-center">
              <div class="text-danger" v-if="onlyPCQApplication" style="font-weight:boldx;margin-top:15px;margin-bottom:15px;">
                <h3>Only allowed for PCQ (Physically Challenged Quota) in this unit.</h3>
              </div>
              <div style="width: 100%; display: flex;" class="justify-content-center " v-if="!isAButtonLoading">
                <button v-if="applicationApplicable && openCall && !closeCall" class="btn info-btn btn-info radius-1 mx-auto" type="submit" block>
                  Apply {{applicationForm.unit}} Unit
                </button>

                <button v-if="!closeAdmitCard && (applicationForm.status=='completed' || applicationForm.status=='paid') && openAdmitCard" @click="downloadAdmitCard" :disabled="isDownloadingAdmitCard" style="margin:4px;float:right" class="btn info-btn btn-info radius-1" type="button" block>
                  <i v-if="isDownloadingAdmitCard" class="fa fa-spinner fa-spin"></i>
                  {{ isDownloadingAdmitCard ? admitCardProgress : 'Admit Card' }}
                </button>
              </div>

              <div v-else  style="max-width: 100%;margin:auto;">
                <button  style="margin-top:10px" :class="isAButtonLoadingClass" type="button" block disabled>
                  <i class="fa fa-spinner fa-spin"></i> Loading...
                </button>
              </div>

              <!-- Payment Options Section -->
              <div class="row center-content" v-if="applicationForm.bill_status=='assigned' && !isPayButtonLoading">
                <div class="checkout-page" style="width: 100%; max-width: 900px; margin: 0 auto;">
                  <div class="checkout-form theme-form">
                    <div class="row center-content">
                      <div class="col-lg-12 col-sm-12 col-xs-12">
                        <div class="theme-card check-out ng-star-inserted">
                          <div class="payment-options-container" >
                            <h5 style="text-align: center; margin-bottom: 25px; color: #2c3e50; font-weight: 600; letter-spacing: 0.5px;">
                              Choose Your Payment Method
                            </h5>

                            <!-- Payment Cards Grid -->
                            <div class="row" style="display: flex; justify-content: center; gap: 10px; flex-wrap: wrap;">

                              <!-- bKash Card -->
                              <div class="col-lg-3 col-md-6 col-sm-6 col-6" style="padding: 5px;">
                                <div class="payment-card" @click="startBkashCheckoutService" style="cursor: pointer; transition: all 0.3s ease; border: 2px solid #e0e0e0; border-radius: 12px; padding: 20px 15px; background: white; box-shadow: 0 2px 8px rgba(0,0,0,0.08); text-align: center; min-height: 140px; display: flex; flex-direction: column; justify-content: center; align-items: center;">
                                  <div class="payment-card-logo" style="margin-bottom: 10px;">
                                    <img alt="bKash" style="height: 60px; max-width: 100%; object-fit: contain;" class="img-fluid" src="../../theme-assets/images/logo/bkash.png">
                                  </div>
                                  <div class="payment-card-title" style="font-size: 14px; font-weight: 600; color: #E2136E; margin-top: 8px;">
                                    bKash
                                  </div>
                                </div>
                              </div>

                              <!-- Rocket Card -->
                              <div class="col-lg-3 col-md-6 col-sm-6 col-6" style="padding: 5px;">
                                <div class="payment-card" @click="startDbblRocketPayment" style="cursor: pointer; transition: all 0.3s ease; border: 2px solid #e0e0e0; border-radius: 12px; padding: 20px 15px; background: white; box-shadow: 0 2px 8px rgba(0,0,0,0.08); text-align: center; min-height: 140px; display: flex; flex-direction: column; justify-content: center; align-items: center;">
                                  <div class="payment-card-logo" style="margin-bottom: 10px;">
                                    <img alt="DBBL Rocket" style="height: 60px; max-width: 100%; object-fit: contain;" class="img-fluid" src="../../theme-assets/images/logo/rocket.png">
                                  </div>
                                  <div class="payment-card-title" style="font-size: 14px; font-weight: 600; color: #8B3A8B; margin-top: 8px;">
                                    Rocket
                                  </div>
                                </div>
                              </div>

                              <!-- Visa Card -->
                              <div class="col-lg-3 col-md-6 col-sm-6 col-6" style="padding: 5px;">
                                <div class="payment-card" @click="startDbblVisaPayment" style="cursor: pointer; transition: all 0.3s ease; border: 2px solid #e0e0e0; border-radius: 12px; padding: 20px 15px; background: white; box-shadow: 0 2px 8px rgba(0,0,0,0.08); text-align: center; min-height: 140px; display: flex; flex-direction: column; justify-content: center; align-items: center;">
                                  <div class="payment-card-logo" style="margin-bottom: 10px;">
                                    <img alt="Visa Card" style="height: 60px; max-width: 100%; object-fit: contain;" class="img-fluid" src="../../theme-assets/images/logo/visa-sq.png">
                                  </div>
                                  <div class="payment-card-title" style="font-size: 14px; font-weight: 600; color: #1434CB; margin-top: 8px;">
                                    Visa Card
                                  </div>
                                </div>
                              </div>

                              <!-- MasterCard -->
                              <div class="col-lg-3 col-md-6 col-sm-6 col-6" style="padding: 5px;">
                                <div class="payment-card" @click="startDbblMasterCardPayment" style="cursor: pointer; transition: all 0.3s ease; border: 2px solid #e0e0e0; border-radius: 12px; padding: 20px 15px; background: white; box-shadow: 0 2px 8px rgba(0,0,0,0.08); text-align: center; min-height: 140px; display: flex; flex-direction: column; justify-content: center; align-items: center;">
                                  <div class="payment-card-logo" style="margin-bottom: 10px;">
                                    <img alt="MasterCard" style="height: 60px; max-width: 100%; object-fit: contain;" class="img-fluid" src="../../theme-assets/images/logo/mastercard-sq.png">
                                  </div>
                                  <div class="payment-card-title" style="font-size: 14px; font-weight: 600; color: #EB001B; margin-top: 8px;">
                                    MasterCard
                                  </div>
                                </div>
                              </div>

                            </div>

                            <p style="text-align: center; margin-top: 20px; color: #6c757d; font-size: 13px; line-height: 1.5;">
                              Click on your preferred payment method to proceed securely
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div v-else-if="applicationForm.bill_status=='assigned' && isPayButtonLoading"  style="max-width: 100%;margin:auto;">
                <button  style="margin-top:10px" :class="isPayButtonLoadingClass" type="button" blockx disabled>
                  <i class="fa fa-spinner fa-spin"></i> Connecting to the payment gateway ...
                </button>
              </div>

            </div>
          </div>
        </form>
      </div>
    </section>
  </div>
</template>

<script>
import AdmitCardGenerator from '../../utils/AdmitCardGenerator'

export default {
  name: 'ProfileApplication',
  props: {
    applicationForm: {
      type: Object,
      required: true
    },
    units: {
      type: Array,
      default: () => []
    },
    unitObj: {
      type: Object,
      default: () => ({})
    },
    quotas: {
      type: Array,
      default: () => []
    },
    applicationApplicable: {
      type: Boolean,
      default: true
    },
    onApplicationLoading: {
      type: Boolean,
      default: false
    },
    closeCall: {
      type: Boolean,
      default: false
    },
    onlyPCQApplication: {
      type: Boolean,
      default: false
    },
    isAButtonLoading: {
      type: Boolean,
      default: false
    },
    isAButtonLoadingClass: {
      type: String,
      default: ''
    },
    openCall: {
      type: Boolean,
      default: false
    },
    closeAdmitCard: {
      type: Boolean,
      default: false
    },
    openAdmitCard: {
      type: Boolean,
      default: false
    },
    closePaymentSlip: {
      type: Boolean,
      default: false
    },
    isPayButtonLoading: {
      type: Boolean,
      default: false
    },
    isPayButtonLoadingClass: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isDownloadingAdmitCard: false,
      admitCardProgress: 'Preparing...'
    }
  },
  methods: {
    selectUnit(unit) {
      this.applicationForm.unit = unit;
      this.getUnitValues();
    },
    onApplicationSubmit() {
      this.$emit('application-submit');
    },
    getUnitValues() {
      this.$emit('unit-change', this.applicationForm.unit);
    },
    onApplicationPaySlip() {
      this.$emit('payment-slip');
    },
    showAdmitCard() {
      this.$emit('admit-card');
    },
    async downloadAdmitCard() {
      if (this.isDownloadingAdmitCard) {
        return
      }

      this.isDownloadingAdmitCard = true
      this.admitCardProgress = 'Preparing...'

      try {
        await AdmitCardGenerator.generateAdmitCard(
          this.applicationForm.unit,
          (message, progress) => {
            this.admitCardProgress = message
          },
          (error) => {
            console.error('Admit card generation error:', error)
            this.$iziToast.error({
              title: 'Error',
              message: error.message || 'Failed to generate admit card. Please try again.'
            })
          }
        )

        // Success notification
        this.$iziToast.success({
          title: 'Success',
          message: 'Admit card downloaded successfully!'
        })
      } catch (error) {
        console.error('Admit card download error:', error)
        this.$iziToast.error({
          title: 'Error',
          message: error.message || 'Failed to download admit card. Please try again.'
        })
      } finally {
        this.isDownloadingAdmitCard = false
        this.admitCardProgress = 'Preparing...'
      }
    },
    startBkashCheckoutService() {
      this.$emit('bkash-payment');
    },
    startDbblRocketPayment() {
      this.$emit('rocket-payment');
    },
    startDbblVisaPayment() {
      this.$emit('visa-payment');
    },
    startDbblMasterCardPayment() {
      this.$emit('mastercard-payment');
    }
  }
}
</script>

<style scoped>
/* Modern Unit Selection Grid */
.unit-selection-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
  gap: 15px;
  padding: 5px 0;
}

/* Hide the actual radio input */
.unit-radio-hidden {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}

/* Unit Card Styling */
.unit-card {
  position: relative;
  background: #ffffff;
  border: 2px solid #e0e7ff;
  border-radius: 12px;
  padding: 20px 15px;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  text-align: center;
  min-height: 110px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.04);
}

.unit-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 16px rgba(99, 102, 241, 0.15);
  border-color: #a5b4fc;
}

/* Eligible Unit */
.unit-card-eligible {
  border-color: #e0e7ff;
  background: linear-gradient(135deg, #ffffff 0%, #f8faff 100%);
}

.unit-card-eligible:hover {
  border-color: #818cf8;
}

/* Selected Unit */
.unit-card-selected {
  background: linear-gradient(135deg, #6366f1 0%, #4f46e5 100%);
  border-color: #4f46e5;
  box-shadow: 0 8px 20px rgba(99, 102, 241, 0.4);
}

.unit-card-selected:hover {
  transform: translateY(-3px);
  box-shadow: 0 12px 24px rgba(99, 102, 241, 0.5);
}

.unit-card-selected .unit-label {
  color: #ffffff;
  font-weight: 700;
}

.unit-card-selected .unit-check-indicator i {
  color: #ffffff;
}

/* Ineligible Unit */
.unit-card-ineligible {
  background: linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%);
  border-color: #fecaca;
  opacity: 0.75;
  cursor: not-allowed;
}

.unit-card-ineligible:hover {
  transform: none;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.04);
  border-color: #fecaca;
}

.unit-card-ineligible .unit-label {
  color: #991b1b;
}

/* Unit Card Content */
.unit-card-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  width: 100%;
}

/* Check Indicator */
.unit-check-indicator {
  font-size: 24px;
  margin-bottom: 5px;
}

.unit-check-indicator i {
  color: #6366f1;
  transition: all 0.3s ease;
}

.unit-card:hover .unit-check-indicator i {
  transform: scale(1.1);
}

/* Unit Label */
.unit-label {
  font-size: 20px;
  font-weight: 600;
  color: #1e293b;
  letter-spacing: 0.5px;
  transition: all 0.3s ease;
}

/* Status Badge for Ineligible Units */
.unit-status-badge {
  font-size: 11px;
  font-weight: 600;
  color: #dc2626;
  background: #ffffff;
  padding: 4px 10px;
  border-radius: 12px;
  margin-top: 5px;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  box-shadow: 0 2px 4px rgba(220, 38, 38, 0.15);
}

.unit-status-badge i {
  font-size: 12px;
}

.theme-form input[type="text"]{
  min-width: 100% !important;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .unit-selection-grid {
    grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
    gap: 12px;
  }

  .unit-card {
    padding: 15px 10px;
    min-height: 95px;
  }

  .unit-label {
    font-size: 18px;
  }

  .unit-check-indicator {
    font-size: 20px;
  }
}

@media (max-width: 480px) {
  .unit-selection-grid {
    grid-template-columns: repeat(auto-fill, minmax(85px, 1fr));
    gap: 10px;
  }

  .unit-card {
    padding: 12px 8px;
    min-height: 85px;
  }

  .unit-label {
    font-size: 16px;
  }
}
</style>
